import {createApi} from '@reduxjs/toolkit/query/react'
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {AziendaNavRecord} from "@commons/mapping/AziendaNavRecord";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {Aziende} from "@commons/mapping/DataTablesSchema";
import {addBaseQueryParams, AziendaFilterSelection, transformResponse} from "@commons/utils/APIParams";
import {config} from "@commons/config.instance";
import {AziendaFruibileRecord} from "@commons/mapping/AziendaFruibileRecord";

export const aziendaApi = createApi({
    reducerPath: 'aziendaApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    endpoints: (builder) => ({
        getAziendaNav: builder.query<AziendaNavRecord, { path: string }>({
            query: ({path}) => {
                return path;
            },
            transformResponse
        }),

        getListaAzienda: builder.query<AziendaFruibileRecord[], 0>({
            query: () => {
                return `/access/domain/current/company-employee`;
            },
            transformResponse
        }),

        getAzienda: builder.query<AziendaRecord, { idAzienda: number }>({
            query: ({idAzienda}) => {
                return `/azienda/${idAzienda}`;
            },
            transformResponse
        }),

        getCurrentSelection: builder.query<Aziende, Partial<AziendaFilterSelection>>({
            query: (filter) => {
                let params: string[] = [];
                if (filter.codAzienda) params.push('filter_codAzienda=' + filter.codAzienda);
                if (filter.codFiliale) params.push('filter_codFiliale=' + filter.codFiliale);
                if (filter.denominazione) params.push('filter_denominazione=' + filter.denominazione);
                if (filter.unitaLocale) params.push('filter_unitaLocale=' + filter.unitaLocale);

                addBaseQueryParams(filter, params);

                return `/access/domain/current/azienda?${params.length > 0 ? '&' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse
        }),
    }),
})
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
// Fino al 08/1/2025
//export const {useGetAziendaNavQuery, useGetAziendaQuery, useGetCurrentSelectionQuery,useGetListaAziendaQuery} = aziendaApi;
// Dal 09/1/2025
export const {useGetAziendaNavQuery, useGetAziendaQuery, useGetCurrentSelectionQuery,} = aziendaApi;